  <div class="debug-header">
    <div class="header-item back-item"><a routerLink="/" mat-button>Back To Home</a></div>
    <div class="header-item title-item">{{pageTitle}}</div>
    <div class="header-item"></div>
  </div>
  <div class="debug-content" style="white-space: pre-wrap;background-color: white;color: black;">{{pageBody}}</div>
  <div class="main-footer-toolbar">
    <button mat-raised-button (click)="CleanupLog()">Clear</button>
    <button mat-raised-button (click)="ShowDebugLog()" color="primary">Debug</button>
    <button mat-raised-button (click)="ShowInfoLog()" color="accent">Info</button>
    <button mat-raised-button (click)="ShowErrorLog()" color="warn">Error</button>
  </div>